import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { sendEvent } from "../../helpers/analytics";

class Template1 extends Component {
  render () {
    const { article } = this.props
    const images = article.images
    const imgPrefix = '/images/article'

    return (
      <div className="article__template1" id="top">
        <div className="article" >
          <div className="article__bg" style={{backgroundImage: `url('${imgPrefix}${article.bg}')`}} />

          <div className="container">
            <div className="article__head">
              <h1 className="article__title">{article.title}</h1>
            </div>

            <div className="article__main">
              <div className="article__section">
                <div className="article__text">
                  <div className="article__author">{article.person}</div>
                  <p>{article.quote}</p>
                </div>

              </div>

              <div className="article__section">
                <div className="article__image">
                  <h2>{article.places[0].title_original}</h2>
                  <h3>{article.places[0].title_russian}</h3>
                  <img src={`${imgPrefix}${images[0]}`} alt=""/>
                </div>
                <div className="article__text">
                  <p>{article.places[0].text}</p>
                </div>

              </div>

              <div className="article__section">
                <div className="article__text">
                  <p>{article.places[1].text}</p>
                </div>
                <div className="article__image">
                  <h2>{article.places[1].title_original}</h2>
                  <h3>{article.places[1].title_russian}</h3>
                  <img src={`${imgPrefix}${images[1]}`} alt=""/>
                </div>
              </div>

              <div className="article__section">
                <div className="article__image">
                  <h2>{article.places[2].title_original}</h2>
                  <h3>{article.places[2].title_russian}</h3>
                  <img src={`${imgPrefix}${images[2]}`} alt=""/>
                </div>
                <div className="article__text">
                  <p>{article.places[2].text}</p>
                </div>
              </div>

              <div className="article__section">
                <div className="article__text">

                  <p dangerouslySetInnerHTML={{__html: article.places[3].text}}></p>
                </div>
                <div className="article__image">
                  <h2  dangerouslySetInnerHTML={{__html: article.places[3].title_original}}></h2>
                  <h3>{article.places[3].title_russian}</h3>
                  <img src={`${imgPrefix}${images[3]}`} alt=""/>
                </div>
              </div>

              <div className="article__section">
                <div className="article__image">
                  <h2>{article.places[4].title_original}</h2>
                  <h3>{article.places[4].title_russian}</h3>
                  <img src={`${imgPrefix}${images[4]}`} alt=""/>
                </div>
                <div className="article__text">
                  <p>{article.places[4].text}</p>
                </div>
              </div>
              <div className="article__section">
                <div className="article__text --full">
                  <p>{article.schedule}</p>
                </div>
              </div>
            </div>
            <div className="article__buttons">
              <span onClick={() => sendEvent('article', 'click', 'up')}>
                <AnchorLink className="button button--to_top" href='#top'>
                  <span className="arrow_up"></span>
                  <span>Наверх</span>
                </AnchorLink>
              </span>
              <a href="http://s7.ru?utm_source=lentaru&utm_medium=banner&utm_campaign=special_project" target="_blank" rel="noopener noreferrer" className="button button--primary" onClick={() => sendEvent('article', 'click', 'know-more')}>Полететь</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Template1


// WEBPACK FOOTER //
// ./src/components/articles/template1.js